import React from 'react';
import { toast } from 'react-toastify';

const CustomNotification = ({ data }) => (
    <div className="flex flex-col w-full">
        <h5 className={'text-sm font-semibold text-zinc-800'}>
            {data.title}
        </h5>
        <div className="flex items-center justify-between">
            <p className="text-sm">{data.content}</p>
        </div>
    </div>
);

export const notifyError = (title: string, content: string) => {
    toast.error(CustomNotification, {
        data: {
            title: title,
            content: content
        }
    });
}

export const notifyInfo = (title: string, content: string) => {
    toast.info(CustomNotification, {
        data: {
            title: title,
            content: content
        }
    });
}

export const notifySuccess = (title: string, content: string) => {
    toast.success(CustomNotification, {
        data: {
            title: title,
            content: content
        }
    });
}